module.exports = __webpack_public_path__ + "static/images/live-active.66e13a6.png";